const REFRESH_LOCK_KEY = "api_client_refreshing";
const REFRESH_LOCK_TIMEOUT = 70000;

export const setRefreshingLock = (isLocked: boolean): void => {
  try {
    if (isLocked) {
      localStorage.setItem(REFRESH_LOCK_KEY, Date.now().toString());
    } else {
      localStorage.removeItem(REFRESH_LOCK_KEY);
    }
  } catch {
    
  }
};

export const isRefreshingInAnyTab = (): boolean => {
  try {
    const lockTime = localStorage.getItem(REFRESH_LOCK_KEY);
    if (!lockTime) return false;

    const lockAge = Date.now() - parseInt(lockTime, 10);
    const isLocked = lockAge < REFRESH_LOCK_TIMEOUT;

    if (!isLocked) {
      localStorage.removeItem(REFRESH_LOCK_KEY);
    }

    return isLocked;
  } catch {
    return false;
  }
};
